import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Segmented,
  Select,
  Spin,
  notification,
} from "antd";
import countryCodes from "../utils/CountryCodes.json";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Icon from "../assets/Icon";
import RegistrationLeftSide from "../components/RegistrationLeftSide";
import { signupApi } from "../api/common";

const Signup = () => {
  const [form] = Form.useForm();
  const [selectedUserRole, setSelectedUserRole] =
    useState("JOBDRONA_CANDIDATE");
  const [changedPass, setChangedPass] = useState();
  const [tab, setTab] = useState("JOBDRONA_CANDIDATE");
  const [changedPassConfirm, setChangedPassConfirm] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phoneNumber: "",
    countryCode: "",
    termsAgree: false,
  });

  const [loading, setLoading] = useState(false);
  const [termCondFlag, setTermCondFlag] = useState(false);

  const checkboxChange = (e) => {
    setTermCondFlag(e.target.checked);
  };

  const handleChange = (value) => {
    // console.log(value);
    const countryEl = document.querySelector(".country-select");
    countryEl.querySelector(".ant-select-selection-item").innerHTML = value;
  };

  const handleTermCon = () => {
    const currentUrl = window.location.href;
    let redirectUrl = "";

    if (currentUrl.includes("dev")) {
      // Redirect to dev environment access page
      redirectUrl = "https://dev.hireplusplus.com/terms-and-conditions";
    } else if (currentUrl.includes("localhost")) {
      // Redirect to dev environment access page for localhost
      redirectUrl = "https://dev.hireplusplus.com/terms-and-conditions";
    } else {
      // Redirect to production environment access page
      redirectUrl = "https://hireplusplus.com/terms-and-conditions";
    }

    window.open(redirectUrl, "_blank");
  };

  const callSignupApi = async (values) => {
    let emailSmall = values?.email?.toLowerCase();
    const encodedEmail = btoa(emailSmall);
    const encodedPassword = btoa(values.password);

    const url = signupApi;
    const data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: encodedEmail,
      mobileNumber: values.phoneNumber,
      countryCode: values.countryCode,
      password: encodedPassword,
      userRole: selectedUserRole,
    };
    setLoading(true);
    // console.log(data);

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      setLoading(false);
      if (result.resultStatusInfo.resultCode.toLowerCase() === "success") {
        // message.success("Registration successful! Redirecting to login...");
        notification.success({
          message: "Registration Completed",
          description: `Verification email sent to ${values.email} Successfully.`,
          placement: "top",
          showProgress: true,
        });
        setTimeout(() => {
          window.location.href = "/login";
        }, 4000);
      } else if (result.resultStatusInfo.resultCode === "USER_EXISTS") {
        notification.warning({
          message: "User exists",
          description: `User already exists. Please try with a different email.`,
          placement: "top",
          showProgress: true,
        });
      } else {
        notification.error({
          message: "Failed",
          description: `Registration Failed.`,
          placement: "top",
          showProgress: true,
        });
      }
    } catch (error) {
      setLoading(false);
      notification.error({
        message: "Failed",
        description: `Registration Failed.`,
        placement: "top",
        showProgress: true,
      });
      // setError(error.message);
      console.log(error);
    }
  };

  const onFinish = (values) => {
    callSignupApi(values);
  };
  useEffect(() => {
    if (changedPass?.length > 0 && changedPassConfirm?.length > 0) {
      form.setFieldsValue({
        confirmPassword: form.getFieldValue("confirmPassword"),
      });
      form.validateFields(["confirmPassword"]);
    }
  }, [changedPass]);

  useEffect(() => {
    const countryEl = document.querySelector(".country-select");
    countryEl.querySelector(".ant-select-selection-item").innerHTML = "+91";
  }, []);

  const strictFilterOption = (input, option) => {
    const normalizedInput = input.toLowerCase();

    const optionText = option.children[0].toLowerCase();
    const optionCode = option.children[2].toLowerCase();

    return (
      optionText.includes(normalizedInput) ||
      optionCode.includes(normalizedInput)
    );
  };

  const handleRoleChange = (value) => {
    setSelectedUserRole(value);
  };

  return (
    <>
      {loading && <Loader />}
      <div className=" main-div ">
        <Row className="login-container  min-h-[90vh] ">
          <Col className=" left-div-cont sm:block hidden">
            <RegistrationLeftSide selectedUserRole={selectedUserRole} />
          </Col>
          <div className=" p-0 m-0 h-0  w-full  res-logo">
            <Icon type="hire-logo" width={80} height={60} />
          </div>
          <Col className="login-form ">
            <div className=" sm:hidden flex items-center justify-start ">
              <div className="px-8 py-4 flex items-center gap-x-2">
                <Icon type="jobdrona-logo" width={35} />
                <span className="font-semibold leading-10 text-[1.2rem] text-orangish">
                  JobDrona
                </span>
              </div>
            </div>
            <div className="m-auto login-div max-w-[580px]">
              <p className="new-login-text p-0 m-0 mb-[0.5rem] flex justify-between items-center">
                Sign up{" "}
              </p>
              {/* <Segmented
                options={[
                  {
                    label: "Candidate",
                    value: "JOBDRONA_CANDIDATE",
                  },
                  // {
                  //   label: "Employer",
                  //   value: "EMPLOYER",
                  // },
                ]}
                onChange={(value) => {
                  setTab(value);
                  setSelectedUserRole(value)
                }}
                className="w-full mb-3"
                block
                size="large"
              /> */}
              <Form
                name="signup"
                form={form}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                // onFinishFailed={onFinishFailed}
                layout="vertical"
                style={{ margin: "auto" }}
              >
                <Row gutter={16}>
                  <Col span={12} className="p-0 m-0 mb-2">
                    <Form.Item
                      label={
                        <span className="text-[#344054] font-medium">
                          First Name
                        </span>
                      }
                      name="firstName"
                      className="p-0 m-0"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your first name!",
                        },
                      ]}
                    >
                      <Input placeholder="Enter your name" size="large" />
                    </Form.Item>
                  </Col>
                  <Col span={12} className="p-0 m-0 mb-2">
                    <Form.Item
                      label={
                        <span className="text-[#344054] font-medium">
                          Last Name
                        </span>
                      }
                      name="lastName"
                      className="p-0 m-0"
                      rules={[
                        {
                          required: true,
                          message: "Please enter your last name!",
                        },
                      ]}
                    >
                      <Input placeholder="Enter your name" size="large" />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  label={
                    <span className="text-[#344054] font-medium">
                      Phone Number
                    </span>
                  }
                  className="p-0 m-0 mb-2"
                >
                  <Input.Group compact>
                    <Form.Item
                      name="countryCode"
                      initialValue="+91"
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "Please select your country code!",
                        },
                      ]}
                    >
                      <Select
                        className="country-select"
                        style={{ width: "25%" }}
                        defaultValue="+91"
                        showSearch
                        onChange={handleChange}
                        size="large"
                        placeholder="Select a country"
                        filterOption={strictFilterOption}
                        dropdownStyle={{ width: "300px" }}
                      >
                        {countryCodes.map((country, index) => (
                          <Select.Option
                            key={country.name}
                            value={country.code}
                          >
                            {country.name} ({country.code})
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="phoneNumber"
                      noStyle
                      rules={[
                        {
                          required: true,
                          message: "Please enter your phone number!",
                        },
                      ]}
                    >
                      <Input
                        style={{ width: "75%" }}
                        placeholder="7********"
                        size="large"
                        type="number"
                        className="custom-number-input"
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>

                <Form.Item
                  label={
                    <span className="text-[#344054] font-medium">Email</span>
                  }
                  name="email"
                  className="p-0 m-0 mb-2"
                  rules={[
                    { required: true, message: "Please enter your email!" },

                    {
                      type: "email",
                      message: "The input is not a valid email!",
                    },
                  ]}
                >
                  <Input placeholder="Enter your email" size="large" />
                </Form.Item>

                <Form.Item
                  label={
                    <span className="text-[#344054] font-medium">Password</span>
                  }
                  name="password"
                  className="p-0 m-0 mb-2"
                  rules={[
                    { required: true, message: "Please create a password!" },
                    {
                      min: 8,
                      message: "Password must be at least 8 characters long!",
                    },
                    {
                      pattern:
                        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$.()-{}|\;:'"_+,<>=~`#!%*?&]{8,}$/,
                      message:
                        "Password must contain at least one capital letter, one number, and one special character!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Create a password"
                    size="large"
                    onChange={(e) => setChangedPass(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  label={
                    <span className="text-[#344054] font-medium">
                      Confirm Password
                    </span>
                  }
                  name="confirmPassword"
                  className="p-0 m-0 mb-2"
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match!")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    placeholder="Confirm password"
                    size="large"
                    onChange={(e) => setChangedPassConfirm(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  className="p-0 m-0 "
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    {
                      validator: (_, value) =>
                        value
                          ? Promise.resolve()
                          : Promise.reject(
                              "Please accept the terms and conditions"
                            ),
                    },
                  ]}
                >
                  <Checkbox onChange={checkboxChange} className="m-0 p-0">
                    I accept all the{" "}
                    <span
                      className="text-[#206DC5] font-semibold"
                      // onClick={handleTermCon}
                    >
                      Terms and Conditions
                    </span>
                    .
                  </Checkbox>
                </Form.Item>

                <Form.Item className="p-0 m-0 mt-2 mb-2">
                  <button
                    disabled={!termCondFlag}
                    className={` ${
                      !termCondFlag ? "btn-disabled" : "btn-orange"
                    } py-2 px-3 w-full`}
                    size="large"
                    htmlType="submit"
                    block
                  >
                    Sign up
                  </button>
                </Form.Item>

                {/* <Form.Item>
                                Already have an account? <a href="">Login</a>
                            </Form.Item> */}
              </Form>
              <p className="text-center new-login-sub-text pb-2 ">
                Already have an account?{" "}
                <Link className="text-[#206DC5] font-semibold" to="/login">
                  Log in
                </Link>
              </p>
            </div>
          </Col>
        </Row>
        <div className="copyright-mobile text-[0.82rem] ml-2 flex items-center text-greyish">
          © {new Date().getFullYear()} Copyright JobDrona, India. All rights
          reserved.
        </div>
      </div>
    </>
  );
};

export default Signup;
